import React, { useState, useEffect } from 'react';
import Tab from './components/Tab';
import { useTranslation } from 'react-i18next';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { PaymentHistory } from './paymentHistory';
import { useLifeUserPayment } from 'all-in-one-shared-api';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Typography, Button, Divider, Row, Grid } from 'antd';
import { isLocaleEnglish } from 'utils';
import RegisterBadge from 'pages/life/registration/RegisterCard/RegisterBadge';
// import blackCancel from 'assets/images/blackCancel.svg';
import placeholderImg from 'assets/images/placeholder-image.svg';
import forward from 'assets/images/forward-arrow.svg';
import imgUrl from 'assets/images/foto.svg';
import { changeDataFun } from 'utils';
import ThreeItemColumn from 'components/threeItemColumn';
import QrCodeModal from './components/QrCodeModal';
import GreetingSection from '../../components/navbar/GreetingSection';
import { Spinner } from 'components';
const { useBreakpoint } = Grid;
const { Text } = Typography;
const PaymentsPage = () => {
  const MainContainer = styled.div`
    width: '500px';
    background-color: white;
    display: flex;
    flex-direction: row;
    border-bottom-width: 1px;
    border-bottom-color: #ddd;
    padding: 16px;
    border-top-left-radius: 10px; /* 添加圆角 */
    border-top-right-radius: 10px; /* 添加圆角 */
  `;
  const BottomContainer = styled.div`
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-top-width: 1px;
    border-top-color: #ddd;
  `;
  const Wrapper = styled.div`
    padding: 80px;
    padding-top: 24px;

    @media (max-width: 600px) {
      padding: 0;
      padding-top: 12px;
    }
  `;
  interface LifeUserPaymentDataList {
    policyNumberNew: string;
    premiumAmountHKD: string;
    productCategory: string;
    productCategoryUrl: string;
    productCategoryEn: string;
    productCategoryTC: string;
    productName: string;
    productNameTc: string;
    policyStatusCode: string;
    policyStatus: string;
    policyStatusTc: string;
    colour: string;
    paymentStateCode: string;
    paymentState: string;
    paymentStateTC: string;
    policyNumber: string;
    insuredName: string;
    // insuredNameTC: string;
    premiumDueDate: string;
    currency: string;
    currencyDesc: string;
    currencyDescTc: string;
    amount: string;
    salesUnitCode: string;
    paymentMethod: string;
    premiumStatus: string;
    companyCode: string;
  }
  const [loading, setLoading] = useState(true);
  const [noPayment, setNoPayment] = useState(false);
  const [lifeUserPaymentData, setLifeUserPaymentData] = useState((): LifeUserPaymentDataList[] => [
    {
      policyNumberNew: '',
      premiumAmountHKD: '',
      productCategory: '',
      productCategoryUrl: '',
      productCategoryEn: '',
      productCategoryTC: '',
      productName: '',
      productNameTc: '',
      policyStatusCode: '',
      policyStatus: '',
      policyStatusTc: '',
      colour: '',
      paymentStateCode: '',
      paymentState: '',
      paymentStateTC: '',
      policyNumber: '',
      insuredName: '',
      // insuredNameTC: '',
      premiumDueDate: '',
      currency: '',
      currencyDesc: '',
      currencyDescTc: '',
      amount: '',
      salesUnitCode: '',
      paymentMethod: '',
      premiumStatus: '',
      companyCode: '',
    },
  ]);
  const [tabIndex, setTabIndex] = useState(0);
  interface LocationState {
    tabs?: number;
    policyNumber: string;
  }
  const [bottomCardShow, SetbottomCardShow] = useState(true);
  const location = useLocation();
  const { tabs, policyNumber } = (location.state as LocationState) ?? {};
  const navigate = useNavigate();
  // const navigation = useNavigation<StackNavigationProp<LifePaymentStackParamList>>();
  // const navigation1 = useNavigation<StackNavigationProp<RootStackParamList>>();
  const handlePayButton = (policyNumber: string, companyCode: string, paymentStateCode: string) => {
    navigate('/LIPayment/PaymentDetails', { state: { policyNumber, companyCode, paymentStateCode } });
  };
  //const mockData = 0
  // const formatCurrency = (number, currency = 'USD', locale = 'en-US') => {
  //   return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(number);
  // };

  const imageUrl = true;
  const { i18n, t } = useTranslation();
  // const link = '';
  const { token } = useKeycloakReady();

  // const [svgContents, setSvgContents] = useState<string[]>([]);
  const [qrCodeModal, setQrCodeModal] = useState(false);
  const {
    shouldFetch: LifeUserPaymentShouldFetch,
    data: useLifeUserPaymentData,
    error: useLifeUserPaymentError,
  } = useLifeUserPayment('useLifeUserPayment', token || '', {
    onSuccess: () => {
      setLoading(false);
    },
    onError: () => {
      setNoPayment(true);
      setLoading(false);
    },
  });
  useEffect(() => {
    LifeUserPaymentShouldFetch(true);
  }, [LifeUserPaymentShouldFetch]);
  useEffect(() => {
    if (tabs) {
      setTabIndex(tabs);
    }
  }, [tabs]);
  // const route = useRoute<RouteProp<LifePaymentStackParamList, 'LifePaymentScreen'>>();
  // console.log('route.params', route.params);
  // const { tabs } = route.params;
  // useEffect(() => {
  //   const onFocus = () => {
  //     if (tabIndex === 0 || (tabs && tabs) === '2') {
  //       useLifeUserPaymentShouldFetch(true);
  //     }
  //     if (tabIndex === 1 || (tabs && tabs) === '1') {
  //       setTabIndex(1);
  //     }
  //   };

  //   const onBlur = () => {
  //     useLifeUserPaymentShouldFetch(false);
  //   };

  //   // 绑定事件
  //   window.addEventListener('focus', onFocus);
  //   window.addEventListener('blur', onBlur);

  //   // 清理副作用
  //   return () => {
  //     window.removeEventListener('focus', onFocus);
  //     window.removeEventListener('blur', onBlur);
  //   };
  // }, [tabIndex, location.state]);
  // useEffect(() => {
  //   if (tabIndex === 0) {
  //     useLifeUserPaymentShouldFetch(true);
  //   }
  // }, [tabIndex]);
  useEffect(() => {
    // const data1 = [
    //   {
    //     policyNumberNew: '3123123',
    //     premiumAmountHKD: '2312312',
    //     productCategory: 'LIFE' /*--Logo的判斷標識*/,
    //     productCategoryUrl:
    //       'https://repository.generali.com.hk/GenBravo/uat/icons/02-life-protection.svg' /*--Logo的路徑,後台目前給的是空值後續會替換為logo的圖片地址*/,
    //     productCategoryEn: 'Life Protection' /*--產品類別*/,
    //     productCategoryTC: '人壽保障' /*--產品類別中文*/,
    //     productName: 'Financial Protection Plan for Members of The RHKPF' /*--產品名稱*/,
    //     productNameTc: 'Financial Protection Plan for Members of The RHKPF' /*--產品名稱中文*/,
    //     policyStatusCode: 'EX' /*--產品狀態類別代碼*/,
    //     policyStatus: 'Expired' /*--產品狀態*/,
    //     policyStatusTc: '到期' /*--產品狀態中文*/,
    //     colour: 'RED' /*狀態顏色*/,
    //     paymentStateCode: 'Due' /*--支付狀態代碼*/,
    //     paymentState: 'Payment Due' /*--支付狀態*/,
    //     paymentStateTC: '到期付款' /*--支付狀態中文*/,
    //     policyNumber: '00001252' /*--保單號*/,
    //     insuredName: 'DUMMY-GIV-03003527DUMMY-SUR-03003527' /*--被保險人名稱*/,
    //     premiumDueDate: '20-Sep-2024' /*--保費到期日*/,
    //     currency: 'HKD' /*--貨幣單位*/,
    //     amount: '420.0' /*--保額*/,
    //     salesUnitCode: 'RTLIF' /*--ZA判斷標識*/,
    //     paymentMethod: 'FPS' /*--支付方式*/,
    //     premiumStatus: 'Pay' /*--也是支付狀態, 頁面區分是Processing和Pay*/,
    //     companyCode: '2' /*--公司代碼*/,
    //     currencyDesc: 'HKD' /*--貨幣描述*/,
    //     currencyDescTc: '港幣' /*--貨幣描述中文*/,
    //   },
    //   {
    //     policyNumberNew: '3123123',
    //     premiumAmountHKD: '2312312',
    //     productCategory: 'LIFE' /*--Logo的判斷標識*/,
    //     productCategoryUrl:
    //       'https://repository.generali.com.hk/GenBravo/uat/icons/02-life-protection.svg' /*--Logo的路徑,後台目前給的是空值後續會替換為logo的圖片地址*/,
    //     productCategoryEn: 'Life Protection' /*--產品類別*/,
    //     productCategoryTC: '人壽保障' /*--產品類別中文*/,
    //     productName: 'Financial Protection Plan for Members of The RHKPFaaaaaaaa' /*--產品名稱*/,
    //     productNameTc: 'Financial Protection Plan for Members of The RHKPF' /*--產品名稱中文*/,
    //     policyStatusCode: 'EX' /*--產品狀態類別代碼*/,
    //     policyStatus: 'Expired' /*--產品狀態*/,
    //     policyStatusTc: '到期' /*--產品狀態中文*/,
    //     colour: 'GREEN' /*狀態顏色*/,
    //     paymentStateCode: 'Due' /*--支付狀態代碼*/,
    //     paymentState: 'Payment Due' /*--支付狀態*/,
    //     paymentStateTC: '到期付款' /*--支付狀態中文*/,
    //     policyNumber: '00001252' /*--保單號*/,
    //     insuredName: 'DUMMY-GIV-03003527DUMMY-SUR-03003527' /*--被保險人名稱*/,
    //     premiumDueDate: '20-Sep-2024' /*--保費到期日*/,
    //     currency: 'HKD' /*--貨幣單位*/,
    //     amount: '420.0' /*--保額*/,
    //     salesUnitCode: '' /*--ZA判斷標識*/,
    //     paymentMethod: 'FPS' /*--支付方式*/,
    //     premiumStatus: 'Pay' /*--也是支付狀態, 頁面區分是Processing和Pay*/,
    //     companyCode: '2' /*--公司代碼*/,
    //     currencyDesc: 'HKD' /*--貨幣描述*/,
    //     currencyDescTc: '港幣' /*--貨幣描述中文*/,
    //   },
    //   {
    //     policyNumberNew: '3123123',
    //     premiumAmountHKD: '2312312',
    //     productCategory: 'LIFE' /*--Logo的判斷標識*/,
    //     productCategoryUrl:
    //       'https://repository.generali.com.hk/GenBravo/uat/icons/02-life-protection.svg' /*--Logo的路徑,後台目前給的是空值後續會替換為logo的圖片地址*/,
    //     productCategoryEn: 'Life Protection' /*--產品類別*/,
    //     productCategoryTC: '人壽保障' /*--產品類別中文*/,
    //     productName: 'Financial Protection Plan for Members of The RHKPF' /*--產品名稱*/,
    //     productNameTc: 'Financial Protection Plan for Members of The RHKPF' /*--產品名稱中文*/,
    //     policyStatusCode: 'EX' /*--產品狀態類別代碼*/,
    //     policyStatus: 'Expired' /*--產品狀態*/,
    //     policyStatusTc: '到期' /*--產品狀態中文*/,
    //     colour: 'RED' /*狀態顏色*/,
    //     paymentStateCode: 'Overdue' /*--支付狀態代碼*/,
    //     paymentState: 'Payment Due' /*--支付狀態*/,
    //     paymentStateTC: '到期付款' /*--支付狀態中文*/,
    //     policyNumber: '00001252' /*--保單號*/,
    //     insuredName: 'DUMMY-GIV-03003527DUMMY-SUR-03003527' /*--被保險人名稱*/,
    //     premiumDueDate: '20-Sep-2024' /*--保費到期日*/,
    //     currency: 'HKD' /*--貨幣單位*/,
    //     amount: '11420.0' /*--保額*/,
    //     salesUnitCode: 'RTLIF' /*--ZA判斷標識*/,
    //     paymentMethod: 'FPS' /*--支付方式*/,
    //     premiumStatus: 'Pay' /*--也是支付狀態, 頁面區分是Processing和Pay*/,
    //     companyCode: '2' /*--公司代碼*/,
    //     orderNo: 4 /* 排序*/,
    //     currencyDesc: 'HKD' /*--貨幣描述*/,
    //     currencyDescTc: '港幣' /*--貨幣描述中文*/,
    //   },
    //   {
    //     policyNumberNew: '3123123',
    //     premiumAmountHKD: '2312312',
    //     productCategory: 'LIFE' /*--Logo的判斷標識*/,
    //     productCategoryUrl:
    //       'https://repository.generali.com.hk/GenBravo/uat/icons/02-life-protection.svg' /*--Logo的路徑,後台目前給的是空值後續會替換為logo的圖片地址*/,
    //     productCategoryEn: 'Life Protection' /*--產品類別*/,
    //     productCategoryTC: '人壽保障' /*--產品類別中文*/,
    //     productName: 'Financial Protection Plan for Members of The RHKPF' /*--產品名稱*/,
    //     productNameTc: 'Financial Protection Plan for Members of The RHKPF' /*--產品名稱中文*/,
    //     policyStatusCode: 'EX' /*--產品狀態類別代碼*/,
    //     policyStatus: 'Expiredrrrrrrrrrr' /*--產品狀態*/,
    //     policyStatusTc: '到期' /*--產品狀態中文*/,
    //     colour: 'RED' /*狀態顏色*/,
    //     paymentStateCode: 'Due' /*--支付狀態代碼*/,
    //     paymentState: 'Payment Due' /*--支付狀態*/,
    //     paymentStateTC: '到期付款' /*--支付狀態中文*/,
    //     policyNumber: '00001252' /*--保單號*/,
    //     insuredName: 'DUMMY-GIV-03003527DUMMY-SUR-03003527' /*--被保險人名稱*/,
    //     premiumDueDate: '20-Sep-2024' /*--保費到期日*/,
    //     currency: 'HKD' /*--貨幣單位*/,
    //     amount: '420.0' /*--保額*/,
    //     salesUnitCode: 'RTLIF' /*--ZA判斷標識*/,
    //     paymentMethod: 'FPS' /*--支付方式*/,
    //     premiumStatus: 'Processing' /*--也是支付狀態, 頁面區分是Processing和Pay*/,
    //     companyCode: '2' /*--公司代碼*/,
    //     orderNo: 4 /* 排序*/,
    //     currencyDesc: 'HKD' /*--貨幣描述*/,
    //     currencyDescTc: '港幣' /*--貨幣描述中文*/,
    //   },
    // ];
    // setLifeUserPaymentData(data1);
    if (useLifeUserPaymentData) {
      SetbottomCardShow(useLifeUserPaymentData.hideAutoPayFlag == 'Y' ? true : false);
      console.log(useLifeUserPaymentData, 'useLifeUserPaymentData');
      setLifeUserPaymentData(useLifeUserPaymentData.paymentPoliciesData);
      setLoading(false);
    }
  }, [useLifeUserPaymentData, useLifeUserPaymentError]);

  const [
    currentAmount,
    // setCurrentAmount
  ] = useState<LifeUserPaymentDataList | null>(null);

  // const handleCodeButton = (item: LifeUserPaymentDataList) => {
  //   setCurrentAmount(item);
  //   setQrCodeModal(true);
  // };
  const navigateToChangeRequest = () => {
    navigate('/ChangePaymentArrangement');
  };
  const { lg } = useBreakpoint();
  return (
    <>
      <GreetingSection pageName={t('life.Payment.title')} showicon={true} />
      <Tab
        values={[t('life.Payment.payment'), t('life.Payment.history')]}
        selectedIndex={tabIndex}
        onTabPress={(index) => {
          // if (index !== 0) {
          //   useLifeUserPaymentShouldFetch(false);
          // }
          setTabIndex(index);
        }}
      />
      <Wrapper>
        {tabIndex == 1 ? (
          <div
            style={{ padding: '24px', paddingTop: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <PaymentHistory policyNumber={policyNumber} />
          </div>
        ) : loading ? (
          <Spinner />
        ) : (
          <>
            {!noPayment && (
              <>
                <Row gutter={[{ xs: 8, sm: 16, md: 48 }, 24]} justify={lg ? 'start' : 'center'} wrap>
                  {' '}
                  {tabIndex === 0 &&
                    (lifeUserPaymentData && lifeUserPaymentData.length > 0 ? (
                      lifeUserPaymentData.map((item, index) => {
                        return (
                          <ThreeItemColumn key={index}>
                            <div
                              key={index}
                              style={{
                                width: '100%',
                                backgroundColor: 'white',
                                borderRadius: '10px',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // 添加阴影
                              }}
                              // style={{

                              //   shadowColor: '#000000',
                              //   shadowOffset: {
                              //     width: 0,
                              //     height: 5,
                              //   },
                              //   shadowOpacity: 0.1,
                              //   shadowRadius:20,
                              //   elevation: 4,
                              // }}
                              // key={index}
                            >
                              <MainContainer>
                                {item.productCategoryUrl ? (
                                  <img
                                    src={item.productCategoryUrl}
                                    width="30"
                                    height="30"
                                    style={{ border: 'none', marginRight: 10 }}
                                  />
                                ) : (
                                  <div style={{ width: 40 }}></div>
                                )}
                                <div style={{ backgroundColor: 'white', overflow: 'hidden' }}>
                                  <Text style={{ fontSize: '15px', fontFamily: 'Roboto500', color: '#6F7072' }}>
                                    {isLocaleEnglish(i18n.language) ? item.productCategoryEn : item.productCategoryTC}
                                  </Text>
                                  <Text
                                    style={{
                                      lineHeight: '33px',
                                      fontSize: '33px',
                                      // whiteSpace: 'nowrap', // 禁止换行
                                      fontFamily: 'Roboto400',
                                      overflow: 'hidden', // 超过宽度隐藏
                                      textOverflow: 'ellipsis', // 超出文本部分显示省略号
                                      width: '100%', // 可根据需求设置最大宽度
                                      display: 'inline-block', // 设置为块级元素，确保宽度受控
                                    }}
                                  >
                                    {isLocaleEnglish(i18n.language) ? item.productName : item.productNameTc}
                                  </Text>
                                  <RegisterBadge
                                    color={item.colour}
                                    status={isLocaleEnglish(i18n.language) ? item.policyStatus : item.policyStatusTc}
                                  />

                                  <Text
                                    style={{
                                      fontSize: '17px',
                                      color: '#6F7072',
                                      fontFamily: 'Roboto400',
                                      width: '100%', // 可根据需求设置最大宽度
                                      display: 'inline-block', // 设置为块级元素，确保宽度受控
                                      // backgroundColor: 'pink',
                                    }}
                                    type="secondary"
                                  >
                                    {t('registration.policyNumber', { policyNumber: item.policyNumber })}
                                  </Text>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      width: '100%',
                                      justifyContent: 'flex-start',
                                      background: 'white',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        // flexWrap: 'wrap',
                                        // width: '200px',
                                        marginRight: '5px',
                                        background: 'white',
                                      }}
                                    >
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: '17px',
                                          color: '#6F7072',
                                          fontFamily: 'Roboto400',
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {t('registration.insuredname')}
                                      </Text>
                                    </div>
                                    <div style={{ background: 'white', overflow: 'hidden' }}>
                                      <Text
                                        style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}
                                        type="secondary"
                                      >
                                        {t('registration.insuredname2', {
                                          insuredName: item.insuredName,
                                        })}
                                      </Text>
                                    </div>
                                  </div>
                                  {item.premiumDueDate && (
                                    <Text
                                      style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}
                                      type="secondary"
                                    >
                                      {t('registration.dueDate', {
                                        dueDate:
                                          i18n.language == 'en'
                                            ? item.premiumDueDate
                                            : changeDataFun(item.premiumDueDate),
                                      })}
                                    </Text>
                                  )}
                                </div>
                              </MainContainer>
                              {/* <Divider /> */}

                              <BottomContainer
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  paddingRight: '10px', // 修改为 paddingRight，遵循 JavaScript 的 camelCase 规则
                                  paddingLeft: '10px',
                                  paddingTop: '10px',
                                  paddingBottom: '10px',
                                  borderTop: '1px solid #ddd',
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: '17px',
                                    fontFamily: 'Roboto500',
                                    color: item.paymentStateCode === 'Due' ? '#6F7072' : '#C21B17',
                                  }}
                                >
                                  {(isLocaleEnglish(i18n.language) ? item.paymentState : item.paymentStateTC) +
                                    ' - ' +
                                    (isLocaleEnglish(i18n.language) ? item.currencyDesc : item.currencyDescTc) +
                                    item.amount}
                                </Text>
                                {item.salesUnitCode.trim() == 'ZAL' ? null : item.premiumStatus === 'Pay' ? (
                                  <Button
                                    style={{
                                      width: 55,
                                      height: 33,

                                      fontSize: '20px',
                                      fontFamily: 'Roboto500',
                                      display: 'flex', // 使用 flex 布局
                                      justifyContent: 'center', // 水平居中
                                      alignItems: 'center', // 垂直居中
                                      cursor: 'pointer',
                                    }}
                                    type="primary"
                                    onClick={() => {
                                      handlePayButton(item.policyNumber, item.companyCode, item.paymentStateCode);
                                    }}
                                  >
                                    {isLocaleEnglish(i18n.language) ? 'Pay' : '繳費'}
                                  </Button>
                                ) : (
                                  <Text style={{ fontSize: '17px', fontFamily: 'Roboto500', color: '#6F7072' }}>
                                    {isLocaleEnglish(i18n.language) ? 'Processing' : '處理中'}
                                  </Text>
                                )}
                              </BottomContainer>
                              {/* {item.salesUnitCode.trim() == 'ZAL' ? (
                                <BottomContainer
                                  style={{
                                    borderTop: '1px solid #ddd',
                                  }}
                                >
                                  <Text style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
                                    {t('life.Payment.contactAgent')}
                                  </Text>
                                </BottomContainer>
                              ) : null} */}
                              {/* {(item.paymentMethod === 'fps' || item.paymentMethod === 'FPS') &&
                              item.premiumStatus === 'Processing' &&
                              item.salesUnitCode.trim() != 'ZAL' ? (
                                <BottomContainer
                                  style={{
                                    borderTop: '1px solid #ddd',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Text style={{ fontSize: '17px', fontFamily: 'Roboto400', color: '#6F7072' }}>
                                    {t('life.Payment.notComplete')}
                                  </Text>
                                  <Button
                                    style={{
                                      // width: 93,
                                      height: 33,
                                      // marginLeft: 10,
                                      marginRight: 10,
                                      color: '#C21B17',
                                      border: '1px solid #c21b17',
                                      fontSize: '20px',
                                      fontFamily: 'Roboto500',
                                      cursor: 'pointer',
                                    }}
                                    size="small"
                                    onClick={() => {
                                      handleCodeButton(item);
                                    }}
                                  >
                                    {t('life.Payment.QRcode')}
                                  </Button>
                                </BottomContainer>
                              ) : null} */}
                            </div>
                          </ThreeItemColumn>
                        );
                      })
                    ) : (
                      <Text>{t('life.Payment.nopayment')}</Text>
                    ))}
                </Row>
                <Divider />
              </>
            )}
            <Row gutter={[{ xs: 8, sm: 16, md: 48 }, 24]} justify={lg ? 'start' : 'center'} wrap>
              <ThreeItemColumn>
                {tabIndex === 0 && bottomCardShow && (
                  <div
                    style={{
                      backgroundColor: 'white',
                      position: 'relative',
                      borderRadius: '8px',
                      width: '100%',
                      overflow: 'hidden',
                      // marginLeft: '10px',
                    }}
                  >
                    {!imageUrl ? (
                      <img
                        src={placeholderImg}
                        width="100%"
                        height="180"
                        style={{ border: 'none', backgroundColor: 'white', overflow: 'hidden', objectFit: 'cover' }}
                      />
                    ) : (
                      <img
                        src={imgUrl}
                        width="100%"
                        height="106"
                        style={{ border: 'none', overflow: 'hidden', objectFit: 'cover' }}
                      />
                    )}
                    <div style={{ padding: '8px' }}>
                      <Text
                        style={{
                          fontSize: '20px',
                          fontFamily: 'Roboto500',
                          color: '#C21B17',
                          width: '100%', // 可根据需求设置最大宽度
                          display: 'inline-block', // 设置为块级元素，确保宽度受控
                        }}
                      >
                        {t('life.Payment.setupautopay')}
                      </Text>
                      <Text
                        style={{
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          color: '#6F7072',
                          width: '100%', // 可根据需求设置最大宽度
                          display: 'inline-block', // 设置为块级元素，确保宽度受控
                        }}
                      >
                        {t('life.Payment.NeverMiss')}
                      </Text>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          cursor: 'pointer',
                        }}
                        onClick={navigateToChangeRequest}
                      >
                        <Text style={{ fontSize: '20px', fontFamily: 'Roboto500', color: '#6F7072' }}>
                          {t('home.requestKnowMore')}
                        </Text>
                        <img src={forward} style={{ marginLeft: '10px' }} />
                      </div>
                    </div>
                  </div>
                )}
              </ThreeItemColumn>
            </Row>
            {qrCodeModal && (
              <QrCodeModal
                amount={currentAmount?.premiumAmountHKD.replace(/,/g, '')}
                policyNumberNew={currentAmount?.policyNumberNew || ''}
                setModalVisible={(val) => setQrCodeModal(val)}
                companyCode={currentAmount?.companyCode || ''}
                modalVisible={qrCodeModal}
              ></QrCodeModal>
            )}
          </>
        )}
      </Wrapper>
    </>
  );
};

export default PaymentsPage;
